import React from 'react';
import { Link } from 'react-router-dom';

const HeroCarousel: React.FC = () => {
  return (
    <section className="wiziai-hero-section">
      <div className="wiziai-hero-gradient"></div>
      <div className="wiziai-hero-shapes">
        <div className="wiziai-hero-shape-1"></div>
        <div className="wiziai-hero-shape-2"></div>
        <div className="wiziai-hero-shape-3"></div>
      </div>
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-10 col-xl-8 text-center">
            <div className="wiziai-hero-content">
              <h1 className="wiziai-hero-title mb-4 animate__animated animate__fadeInUp">
                Master JEE & NEET with 
                <span className="wiziai-gradient-text-yellow"> WiZiAI</span>
              </h1>
              <p className="wiziai-hero-subtitle mb-5 animate__animated animate__fadeInUp animate__delay-1s">
                Your AI-powered learning assistant that delivers personalized tests, 
                voice-based doubt clarification, and comprehensive performance tracking 
                to accelerate your exam preparation.
              </p>
              <div className="wiziai-hero-features mb-5 animate__animated animate__fadeInUp animate__delay-2s">
                <div className="row g-4 justify-content-center">
                  <div className="col-md-4">
                    <div className="wiziai-feature-item">
                      <div className="wiziai-feature-icon">
                        <i className="fas fa-brain"></i>
                      </div>
                      <h6>Personalized Tests</h6>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="wiziai-feature-item">
                      <div className="wiziai-feature-icon">
                        <i className="fas fa-microphone"></i>
                      </div>
                      <h6>Voice Doubt Solving</h6>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="wiziai-feature-item">
                      <div className="wiziai-feature-icon">
                        <i className="fas fa-chart-line"></i>
                      </div>
                      <h6>Performance Tracking</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="wiziai-hero-cta animate__animated animate__fadeInUp animate__delay-3s">
                <Link 
                  to="/signup" 
                  className="btn wiziai-btn-primary btn-lg px-5 py-3"
                >
                  Start Your Free Trial
                  <i className="fas fa-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
